var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsAirplaneTicketOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85 15.65L17.75 13.3C18 13.2333 18.1877 13.0793 18.313 12.838C18.4383 12.5967 18.4673 12.3507 18.4 12.1C18.3327 11.8493 18.187 11.662 17.963 11.538C17.739 11.414 17.5013 11.3847 17.25 11.45L14.8 12.1L10.8 8.35L9.4 8.7L11.8 12.9L9.4 13.5L8.15 12.55L7.2 12.8L8.85 15.65ZM20 20H4C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V14C2.55 14 3.021 13.8043 3.413 13.413C3.805 13.0217 4.00067 12.5507 4 12C3.99933 11.4493 3.80367 10.9787 3.413 10.588C3.02233 10.1973 2.55133 10.0013 2 10V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.805 4.98 22.0007 5.45067 22 6V18C22 18.55 21.8043 19.021 21.413 19.413C21.0217 19.805 20.5507 20.0007 20 20ZM20 18V6H4V8.55C4.61667 8.91667 5.10433 9.40433 5.463 10.013C5.82167 10.6217 6.00067 11.284 6 12C5.99933 12.716 5.82033 13.3787 5.463 13.988C5.10567 14.5973 4.618 15.0847 4 15.45V18H20Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsAirplaneTicketOutline);
export default __webpack_public_path__ + "static/media/material-symbols_airplane-ticket-outline.a481d2306311983eba1546f88465328d.svg";
export { ForwardRef as ReactComponent };